// extracted by mini-css-extract-plugin
export default {"wrapper":"skeleton_wrapper__rMI5D","tab":"skeleton_tab__S-tIh","head":"skeleton_head__VFxeC","row":"skeleton_row__IvnCX"};